import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { motion } from 'framer-motion';

const UpgradeOverlay = ({ message, buttonText, onUpgrade }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: 'rgba(255, 255, 255, 0.95)',
          zIndex: 1000,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 3,
          textAlign: 'center'
        }}
      >
        <Typography 
          variant="h5" 
          sx={{ 
            mb: 2,
            fontFamily: 'Poppins',
            fontWeight: 600
          }}
        >
          {message}
        </Typography>
        <Button
          variant="contained"
          onClick={onUpgrade}
          sx={{
            mt: 2,
            bgcolor: '#5546ff',
            '&:hover': {
              bgcolor: '#4435ee'
            },
            textTransform: 'none',
            fontFamily: 'Poppins',
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: 2
          }}
        >
          {buttonText}
        </Button>
      </Box>
    </motion.div>
  );
};

export default UpgradeOverlay; 